import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_RENTER_PROFILE_UPDATE_CREDIT_AND_BACKGROUND_DATA } from 'api/actionTypes';

import updateLocalRenterProfile from './updateLocalRenterProfile';

export default async function updateCreditAndBackgroundData({ state, apiClient }, {
  userId,
  applicationId,
  updates,
}) {
  typeCheck('userId::PositiveNumber', userId);
  typeCheck('applicationId::PositiveNumber', applicationId);
  typeCheck('updates::NonEmptyObject', updates);

  return apiClient.postWithState({
    action: SR_API_ACTION_RENTER_PROFILE_UPDATE_CREDIT_AND_BACKGROUND_DATA,
    state: state,
    payload: {
      userId,
      applicationId,
      updates,
    },
    onSuccess() {
      updateLocalRenterProfile({ state }, { userId, updates });
    },
  });
}
